// services/api.js
const BASE_URL = window.location.origin + '/api/internal';

export const fetchPipelineStats = async (filterOptions) => {
  const queryString = new URLSearchParams(filterOptions).toString();

  const response = await fetch(`${BASE_URL}/clients/2/pipeline_stats${queryString ? `?${queryString}` : ''}`);
  if (!response.ok) {
    throw new Error('Failed to fetch pipeline stats');
  }
  return response.json();
};

export const fetches = {
  fetchPipelineStats
}